import { useFormik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { contactSx, FormBox, Heading, MainBox } from "./styles";
import { Box } from "@mui/material";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../Infrastructure/config";
import { USER_LOGS_CLIENT } from "../../Infrastructure/Constants/logsConstant";
import ERROR_CONSTANTS from "../../Infrastructure/Constants/errorConstants";
import useAuthentication from "../../Infrastructure/States/onAuthStateChange";
import {
  StyledOutlinedTextField,
} from '../../Infrastructure/Theme/styledComponents';
import { useDispatch, useSelector } from "react-redux";
import { showErrorModal } from "../../Infrastructure/States/errorModalSlice";
import { ShowSuccessToast } from "../Common/Toast/toast";
import { emailSchema } from "../../Infrastructure/Utilities/emailValidator";
import ButtonLoading from "../Common/Button/ButtonLoading";
import { safeClientLogEvent } from "../../Infrastructure/Utilities/safeClientLogEvent";

const Contact = () => {
  const dispatch = useDispatch()
  const { userId } = useAuthentication()
  const [loading, setLoading] = useState(false)
  const ip = useSelector((state) => state.ip.address)
  const page = useSelector((state)=> state.route.currentRoute)
  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      message: "",
      phoneNumber: "",
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("Full Name"),
      email: emailSchema,
      phoneNumber: Yup.string(),
      message: Yup.string().required("Message")
    }),

    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true)
        const sendEmail = httpsCallable(functions, "sendemail")
        await sendEmail({...values, ip, page})
        resetForm()
        ShowSuccessToast("Message Sent", {position: "top-center"})
      }
      catch (err) {
        setLoading(false)
        dispatch(
          showErrorModal({
            errorMessage: ERROR_CONSTANTS.COURSE_CONTACT_ERROR_MODAL.MESSAGE
          })
        );
        await safeClientLogEvent({
          ...USER_LOGS_CLIENT.CONTACT_FORM_SUBMISSION_FAILED,
          uid: userId || null,
          source: "Contact.jsx",
          emailInfo: { email: values.email },
          metadata: { fullName: values.fullName, phoneNumber: values.phoneNumber },
          error: err?.message || null
        });
      } finally {
        setLoading(false)
      }
    },
  });

  return (
    <>
      <Box sx={contactSx.main}>
            <MainBox>
              <Heading variant="h1">Contact Us</Heading>
              <FormBox component="form" onSubmit={formik.handleSubmit} noValidate>
                <StyledOutlinedTextField
                  name="fullName"
                  label={
                    formik.touched.fullName && Boolean(formik.errors.fullName)
                      ? `${formik.errors.fullName}`
                      : "Full Name"
                  }
                  variant="standard"
                  onChange={formik.handleChange}
                  value={formik.values.fullName}
                  error={formik.touched.fullName && Boolean(formik.errors.fullName)}
                  fullWidth
                />

                <StyledOutlinedTextField
                  name="email"
                  sx={contactSx.emailField}
                  label={
                    formik.touched.email && Boolean(formik.errors.email)
                      ? `${formik.errors.email}`
                      : "Email Address"
                  }
                  variant="standard"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  fullWidth
                />

                <StyledOutlinedTextField
                  name="phoneNumber"
                  sx={contactSx.numberField}
                  label={
                    formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)
                      ? `${formik.errors.phoneNumber}`
                      : "Phone Number (Optional)"
                  }
                  variant="standard"
                  onChange={formik.handleChange}
                  value={formik.values.phoneNumber}
                  error={
                    formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)
                  }
                  InputProps={{
                    inputMode: "numeric",
                    onKeyPress: (event) => {
                      if (isNaN(event.key)) {
                        event.preventDefault();
                      }
                    },
                  }}
                  fullWidth
                />
                <StyledOutlinedTextField
                  name="message"
                  multiline
                  rows={4}
                  mt={5}
                  label={
                    formik.touched.message && Boolean(formik.errors.message)
                      ? `${formik.errors.message}`
                      : "Message"
                  }
                  variant="standard"
                  onChange={formik.handleChange}
                  value={formik.values.message}
                  placeholder="Type your message here"
                  error={formik.touched.message && Boolean(formik.errors.message)}
                  fullWidth
                />

            <Box sx={contactSx.submitBox}>
              <ButtonLoading sx={contactSx.submitButton} type="submit" text="Send Message" loading={loading}/>
            </Box>
          </FormBox>
        </MainBox>
      </Box>
    </>
  );
};

export default Contact;
